'use client'

import React from 'react'
import Logo from "./Logo";
import Link from "next/link";
import { usePathname } from "next/navigation";

interface IHeaderNavParam {
  userId: string | null | undefined
}

function HeaderNav({ userId }: IHeaderNavParam) {
  const pathname = usePathname();

  return (
      <nav className="flex gap-6 text-sm font-medium text-gray-600 items-center w-auto">
        <Logo />
        <div className="hidden md:flex gap-6 ml-4">
          { pathname == '/' 
            ? <span className="text-gray-400">Home</span>
            : <Link href="/" className="hover:text-indigo-600">Home</Link>
          }
          {
            userId && !pathname.includes("/dashboard")
            ? <Link href="/dashboard" className="hover:text-indigo-600">Dashboard</Link>
              : <span className="text-gray-400">Dashboard</span>
          }
          {
            pathname != "/about-us" 
            ? <Link href="/about-us" className="hover:text-indigo-600">About Us</Link>
              : <span className="text-gray-400">About Us</span>
          }
          {
            pathname == '/plans' 
            ? <span className="text-gray-400">Plans</span>
            : <Link href="/plans" className="hover:text-indigo-600">Plans</Link>
          }
        </div>
      </nav>
  )
}

export default HeaderNav;